import {activityPeriod,activityDayBounds,dateKey,emptyActivityBasis,addActivitySegment,activityFromBasis,distanceKm,ACTIVITY_TIMEZONE} from './activity-model.js';

const clock=new Intl.DateTimeFormat('en-GB',{timeZone:ACTIVITY_TIMEZONE,hour:'2-digit',hourCycle:'h23'});
export const ACTIVITY_METRICS=['steps','distanceKm','gpsDistanceKm','activeMinutes','calories','averageSpeedKph'];
export function periodSlots(period,anchor){
 const range=activityPeriod(period,anchor);
 return period==='day'?Array.from({length:24},(_,hour)=>`${anchor}T${String(hour).padStart(2,'0')}`)
  :period==='year'?Array.from({length:12},(_,month)=>`${anchor.slice(0,4)}-${String(month+1).padStart(2,'0')}`):range.days;
}
export function periodSlot(stamp,period){const date=new Date(stamp);if(!Number.isFinite(+date))return null;const day=dateKey(date);return period==='day'?`${day}T${clock.format(date)}`:period==='year'?day.slice(0,7):day;}
/** Split observed segments at clock-hour boundaries; never invent activity in gaps.
 * DST repeats are combined under the same clock hour, and missing hours stay empty. */
export function hourlyActivity(points,anchor,profile){
 const bounds=activityDayBounds(anchor),start=Date.parse(bounds.startAt),end=Date.parse(bounds.endAt);
 const slots=new Map(periodSlots('day',anchor).map(key=>[key,{key,...emptyActivityBasis(),gpsKm:0,gpsSegments:0,reportCount:0}]));
 let previous=null;
 for(const point of points){
  const now=Date.parse(point.receivedAt),slot=slots.get(periodSlot(point.receivedAt,'day'));if(!slot||now<start||now>=end)continue;
  slot.reportCount++;
  if(previous&&point.connectFromPrevious){
   const before=Date.parse(previous.receivedAt),span=now-before;
   if(span>0){const basis=emptyActivityBasis();addActivitySegment(basis,previous,point);const km=distanceKm(previous,point);
    for(let cursor=before;cursor<now;){const next=Math.min(now,(Math.floor(cursor/3600000)+1)*3600000),part=slots.get(periodSlot(cursor,'day')),fraction=(next-cursor)/span;
     if(part){for(const key of ['walkingKm','activeSeconds','caloriePerKg','observedSeconds'])part[key]+=basis[key]*fraction;
      part.observedSegments+=basis.observedSegments;part.usedSegments+=basis.usedSegments;part.ignoredSegments+=basis.ignoredSegments;
      if(Number.isFinite(km)){part.gpsKm+=km*fraction;part.gpsSegments++;}}
     cursor=next;
    }
   }
  }
  previous=point;
 }
 return [...slots.values()].map(row=>({key:row.key,...activityFromBasis(row,profile),gpsDistanceKm:row.gpsSegments?Math.round(row.gpsKm*1000)/1000:null,reportCount:row.reportCount}));
}
export function activityChartRows(summary){
 if(!summary)return [];
 if(summary.period==='day')return summary.hours??periodSlots('day',summary.anchor).map(key=>({key,...Object.fromEntries(ACTIVITY_METRICS.map(k=>[k,null]))}));
 if(summary.period!=='year')return summary.days.map(day=>({...day,key:day.date}));
 return periodSlots('year',summary.anchor).map(key=>{const days=summary.days.filter(d=>d.date.startsWith(key));return {key,...aggregateActivity(days)};});
}
export function aggregateActivity(rows){
 const result=Object.fromEntries(ACTIVITY_METRICS.map(key=>{const values=rows.map(r=>r[key]).filter(Number.isFinite);return [key,values.length?values.reduce((a,b)=>a+b,0):null];}));
 const weighted=rows.filter(r=>Number.isFinite(r.averageSpeedKph)&&r.activeMinutes>0),minutes=weighted.reduce((n,r)=>n+r.activeMinutes,0);
 result.averageSpeedKph=minutes?weighted.reduce((n,r)=>n+r.averageSpeedKph*r.activeMinutes,0)/minutes:null;
 return result;
}
